<!-- 联系我们 -->
<template>
<!--  content-bg-->
<div class="site-content ">
  <div class="site-content-page">
    <div class="content-row">
      <div class="content-col col-per-70">
        <infoContent title="牛油果网简介"  label="INFORMARION" :showTitle="true" :showMore="false" :infoBlock="infoBlock1"/>
        <infoContent title="联系我们" label="INFORMARION" :showTitle="true" :showMore="false" :infoBlock="infoBlock2"/>
      </div>
      <div class="content-col col-per-30">
        <infoList title="推荐政策" label="INFORMARION" :showTitle="true" :showMore="false" :infoBlock="infoBlock3" :infoPage="infoPage3" v-on:queryPage="tjzc_Req" titleLength="18" count="6"/>
        <infoList title="推荐项目" label="INFORMARION" :showTitle="true" :showMore="false" :infoBlock="infoBlock4" :infoPage="infoPage4" v-on:queryPage="tjxm_Req" titleLength="30" count="4"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import InfoList from '../block/InfoList'
import InfoContent from '../block/InfoContent'
import TitleInfoBlock01 from '../block/TitleInfoBlock01'
import YgjjInfo from '../module/YgjjInfo'
import LxwmInfo from '../module/LxwmInfo'
import TjInfo1 from '../module/TjInfo1'
export default {
  name: 'Lxwm01',
  components: {
    'infoList': InfoList,
    'infoContent': InfoContent
  },
  data () {
    return {
      msg: '',
      infoBlock1: YgjjInfo,
      infoBlock2: LxwmInfo,
      infoBlock3: TitleInfoBlock01,
      infoBlock4: TjInfo1,
      infoPage3: {},
      infoPage4: {},
      tabDefaultType: 'policy_library'
    }
  },
  methods: {
    // 推荐政策
    tjzc_Req (params) {
      let that = this
      if (this.Global.siteTabId > 0) { params.tag_id = this.Global.siteTabId }
      params.type = that.tabDefaultType
      let result = {page: params}
      console.log(params.title + '开始请求Vue-axios,参数：' + JSON.stringify(params))
      that.$dataApi.articleList(params).then(res => {
        // console.log('请求Vue-axios结果：'+JSON.stringify(res))
        that.msg = res.msg
        result.list = res.data.list
        result.page.total = res.data.total
        that.infoPage3 = result
        // console.log('结束请求Vue-axios：'+JSON.stringify(result))
      })
    },
    // 推荐项目
    tjxm_Req (params) {
      var date = new Date()
      let that = this
      params.queryYear = date.getFullYear()
      params.queryMonth = date.getMonth() + 1
      if (this.Global.siteTabId > 0) { params.tag_id = this.Global.siteTabId }
      let result = {page: params}
      console.log(params.title + '开始请求Vue-axios,参数：' + JSON.stringify(params))
      that.$dataApi.fastNewsLists(params).then(res => {
        // console.log('请求Vue-axios结果：'+JSON.stringify(res))
        that.msg = res.msg
        result.list = res.data.list
        result.page.total = res.data.total
        that.infoPage4 = result
        // console.log('结束请求Vue-axios：'+JSON.stringify(result))
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col-per-70 {
  flex-grow:3;
}

.col-per-30 {
  flex-grow:1;
  background-color:rgba(255,255,255,0.6);
}

.content-bg{
  background-image:url(./../../assets/lxwm_bg.png);
  background-size:auto 600px;
  background-repeat: repeat;
  background-position: 0;
}

.site-content-page{
  background-color:rgba(0,0,0,0);
}

</style>



// WEBPACK FOOTER //
// src/components/page/Lxwm01.vue